"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportEntityStatusToJSON = exports.ReportEntityStatusFromJSONTyped = exports.ReportEntityStatusFromJSON = exports.ReportEntityStatus = void 0;
/**
 * Ad, Ad Set, and Campaign statuses that are used in report requests as well as responses. Not
 * every status is valid for each entity type. The valid statuses for each entity are the following:
 * Ad: APPROVED, ARCHIVED, PENDING, PENDING_APPROVAL, PENDING_ADVERTISER_APPROVAL, REJECTED
 * Ad Set: ACTIVE, APPROVED, ARCHIVED, COMPLETED, PENDING_APPROVAL, PENDING_ADVERTISER_APPROVAL, READY, REJECTED
 * Campaign: ACTIVE, ARCHIVED, PAUSED
 *
 * Note: The PENDING_ADVERTISER_APPROVAL status is only available for managed service campaigns.
 *
 * @export
 */
exports.ReportEntityStatus = {
    Active: 'ACTIVE',
    Approved: 'APPROVED',
    Archived: 'ARCHIVED',
    PendingApproval: 'PENDING_APPROVAL',
    Rejected: 'REJECTED',
    PendingAdvertiserApproval: 'PENDING_ADVERTISER_APPROVAL',
    Paused: 'PAUSED',
    Completed: 'COMPLETED',
    Ready: 'READY',
    Pending: 'PENDING'
};
function ReportEntityStatusFromJSON(json) {
    return ReportEntityStatusFromJSONTyped(json, false);
}
exports.ReportEntityStatusFromJSON = ReportEntityStatusFromJSON;
function ReportEntityStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ReportEntityStatusFromJSONTyped = ReportEntityStatusFromJSONTyped;
function ReportEntityStatusToJSON(value) {
    return value;
}
exports.ReportEntityStatusToJSON = ReportEntityStatusToJSON;
